import { Component, OnInit } from '@angular/core';
import { BasePage } from '../../base-page';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { MessageService } from 'src/app/services/message.service';
import { StoryGroupModel, StoryPostModel } from 'src/app/models/story/story.model';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-edit-story',
  standalone: false,
  templateUrl: './edit-story.component.html',
  styleUrl: './edit-story.component.scss'
})
export class EditStoryComponent extends BasePage implements OnInit {

  public formGroup = new FormGroup<any>({
    isEnabled: new FormControl(true),
    name: new FormControl('', Validators.required),
    basePost: new FormGroup({
      mediaPath: new FormControl('', [Validators.required]),
      selectFile: new FormControl(''),
      order: new FormControl(1),
      seconds: new FormControl(10),
    }),
    posts: new FormArray([]),
  });

  constructor(
    private mApiService: ApiService,
    private mRouter: Router,
    private mMessageService: MessageService,
    activatedRoute: ActivatedRoute
  ) {
    super();

    if (activatedRoute.snapshot.params['id'] !== 'new') {
      this.formGroup.addControl('id', new FormControl(activatedRoute.snapshot.params['id']));
    }
  }

  ngOnInit(): void {
    this.isBusy = true;
    if (this.formGroup.value.id) {
      this.mApiService.get<StoryGroupModel>(`/api/admin/story/group/${this.formGroup.value.id}`).subscribe({
        next: r => {
          this.formGroup.patchValue(r);

          this.formGroup.setControl('basePost', this.getPostFormGroup(r.basePost))
          for (let item of r.posts) {
            (this.formGroup.controls['posts'] as FormArray).push(this.getPostFormGroup(item));
          }
          this.isBusy = false;
        }, error: () => {
          this.isBusy = false;
        }
      });
    } else {
      this.isBusy = false;
    }
  }

  public save() {

    this.isBusy = true;

    const saveValue = this.formGroup.value;

    if (!saveValue.id) {
      this.mApiService.post<StoryGroupModel, {}>('/api/admin/story/group', saveValue).subscribe({
        next: () => {
          this.mRouter.navigate(['/stories']);

          this.mMessageService.addMessage({ text: 'Сторис сохранена', type: this.mMessageService.types.success });
        }, error: () => this.isBusy = false
      });
    } else {
      this.mApiService.put<StoryGroupModel, {}>('/api/admin/story/group', saveValue).subscribe({
        next: () => {
          this.mRouter.navigate(['/stories']);

          this.mMessageService.addMessage({ text: 'Сторис сохранена', type: this.mMessageService.types.success });
        }, error: () => this.isBusy = false
      });
    }
  }

  public getImageStyle(imagePath?: string) {
    if (imagePath) {
      return {
        'background-image': `url(/${imagePath})`
      };
    }
    return { '': '' }
  }

  public selectFile(event: any, storyValue: FormGroup) {
    if (!event.target.files[0]) {
      return;
    }

    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    this.isBusy = true;

    this.mApiService.formData<{ mediaPath: string }>('/api/admin/story/media/save', formData).subscribe({
      next: (r) => {
        const currentOrder = storyValue.value.order || 1;
        storyValue.patchValue({
          mediaPath: r.mediaPath,
          order: currentOrder
        });

        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });
  }

  public addStoryPost(event: any) {
    if (!event.target.files[0]) {
      return;
    }

    const formData = new FormData();
    formData.append('file', event.target.files[0]);
    this.isBusy = true;

    this.mApiService.formData<{ mediaPath: string }>('/api/admin/story/media/save', formData).subscribe({
      next: (r) => {
        const postsArray = this.formGroup.controls['posts'] as FormArray;
        const sortedPosts = this.getPosts();
        const newOrder = sortedPosts.length > 0 ? Math.max(...sortedPosts.map(p => p.value.order)) + 1 : 1;
        postsArray.push(new FormGroup({
          mediaPath: new FormControl(r.mediaPath, [Validators.required]),
          order: new FormControl(newOrder),
          seconds: new FormControl(10)
        }));
        this.isBusy = false;
      },
      error: () => this.isBusy = false
    });

  }

  public removeStoryPost(index: number) {
    const postsArray = this.formGroup.controls['posts'] as FormArray;
    postsArray.removeAt(index);
    this.updatePostsOrder();
  }

  public postMove(index: number, change: number) {
    const newIndex = index + change;

    const posts = this.getPosts();

    if (newIndex >= posts.length || newIndex < 0) {
      return;
    }

    const swapElement = posts[newIndex];

    posts[newIndex] = posts[index];
    posts[index] = swapElement;

    this.updatePostsOrder();
  }

  public asFormGroup(fg: any) {
    return fg as FormGroup;
  }

  public asFormArray(fa: any) {
    return fa as FormArray;
  }

  public getPosts() {
    return (this.formGroup.controls['posts'] as FormArray).controls;
  }

  public postIsVideo(filePath?: string) {
    if (!filePath) {
      return false;
    }

    const videoExtensions = [
      '.mp4', '.avi', '.mov', '.wmv', '.flv', '.webm',
      '.mkv', '.m4v', '.3gp', '.ogv', '.ts', '.mts'
    ];

    const extension = filePath.toLowerCase().substring(filePath.lastIndexOf('.'));
    return videoExtensions.includes(extension);
  }

  private updatePostsOrder() {
    const sortedPosts = this.getPosts();
    sortedPosts.forEach((control, index) => {
      control.patchValue({ order: index + 1 });
    });
  }

  private getPostFormGroup(post: StoryPostModel) {
    return new FormGroup({
      id: new FormControl(post.id),
      mediaPath: new FormControl(post.mediaPath, [Validators.required]),
      selectFile: new FormControl(''),
      order: new FormControl(post.order),
      seconds: new FormControl(post.seconds)
    });
  }
}

